export default __webpack_public_path__ + "static/media/energy-info.05fa69bc.jpg";